import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ViewBestPluckerPerfromance } from './Pages';

export const ViewBestPluckerPerfromanceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={ViewBestPluckerPerfromance} />
    </Fragment>
)